import type {SpecieRepository} from '@/domain/interfaces/SpecieRepository';
import type {HttpClient} from '@/infrastructure/interfaces/HttpClient';
import type {SpecieDto} from './SpecieDto';
import {toDomain} from './SpecieMapper';

const PATH = 'species/';

export class RestSpecieRepository implements SpecieRepository {
  constructor(private readonly httpClient: HttpClient) {}
  getAll = async () => {
    const dtos = await this.httpClient.get<Array<SpecieDto>>(PATH);
    return dtos.map((dto) => toDomain(dto));
  };
}
